<template>
  <div class="h5" @touchstart="clickApp">
    <header class="n-fixed-top">
      <div class="left" @click="routerGoBack">
        <div class="n-back"></div>
      </div>
      <h4>{{ title }}</h4>
      <div class="right"></div>
    </header>
    <div class="content">
      <iframe
        :src="h5_url"
        frameborder="0"
        scrolling="auto"
        allowfullscreen="true"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        style="width: 100%; height: 100%"
      ></iframe>
      <watermark v-if="moveRange" :position="moveRange"></watermark>
    </div>
    <stagnation-hint
      @touchstart="clickApp"
      v-show="foolproofTime - addictedTime <= 10 && foolproofTime"
    >
      <span>{{ foolproofTime - addictedTime }}秒</span>
    </stagnation-hint>
  </div>
</template>
<script>
import watermark from "components/MyAliplayer/shuiyin";
import stagnationHint from "@/lib/foolproof";
import mixin from "@/lib/defensive";
import { openWS } from "@/utils/lessonws";
export default {
  data() {
    return {
      //   time:
      //     localStorage.getItem('current') != null
      //       ? localStorage.getItem('current')
      //       : 1,
      title: "",
      h5_url: "",
      IntervalTwo: null,
      IntervalThree: null,
      moveRange: "",
      // 当前路由长度
      routerHistoryLng: history.length,
      token: localStorage.getItem("_user_data_sso_token"),
      company_id: localStorage.getItem("_user_data_company_id"),
      user_id: localStorage.getItem("_user_data_id"),
      tid: this.$route.query.tid,
      rid: this.$route.query.rid,
      cid: this.$route.query.cid,
    };
  },
  components: {
    watermark,
    stagnationHint,
  },
  mixins: [mixin],
  created() {
    window.lessonWSOnOpen = function () {
      let json = {
        type: "openLearningTime",
      };
      let str = JSON.stringify(json);
      if (window.lessonWS && window.lessonWS.ws) {
        window.lessonWS.ws.send(str);
      }
    };

    openWS(
      {
        token: localStorage.getItem("_user_data_sso_token"),
        company_id: localStorage.getItem("_user_data_company_id"),
        user_id: localStorage.getItem("_user_data_id"),
        trainplan_id: this.$route.query.tid,
        resources_id: this.$route.query.rid,
      },
      () => {}
    );

    // 页面刷新和关闭事件计时(不包含返回)
    // window.addEventListener('beforeunload', e => this.statisticDuration())
  },
  mounted() {
    this.change_status();
    this.get_datas();
    // 每隔1s计时，不足60s 退出时提交时间
    clearInterval(this.IntervalTwo);
    this.IntervalTwo = setInterval(() => {
      setTimeout(() => {
        if (this.time == 60) {
          this.statisticDuration();
          this.time = 1;
        } else {
          this.time++;
        }
        // console.log('用来数数')
      }, 0);
    }, 1000);
    // 学习体验时间递减
    clearInterval(this.IntervalThree);
    var left_time = localStorage.getItem("left_time");
    if (left_time != null) {
      this.setTimerThree(left_time);
    }
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      // 获取水印的移动范围 (水印的开关)
      this.MoveRange();
    },
    MoveRange() {
      let boxW = $(".content").width();
      // console.log(boxW);
      let boxH = $(".content").height();
      // console.log(boxH);
      this.moveRange = { x: boxW, y: boxH };
    },
    change_status() {
      var url = "/index.php/mobile/study/save-chapter-record";
      var params = {
        sys_id: localStorage.getItem("_sys_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        user_id: localStorage.getItem("_user_data_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        language: localStorage.getItem("_user_data_language"),
        trainplan_id: this.$route.query.tid,
        resources_id: this.$route.query.rid,
        chapter_id: this.$route.query.cid,
      };
      this.$axios.post(url, params).then((res) => {
        if (res.data.code != 0) {
          if (res.data.code == 10600) {
            this.$router.push({ name: "Login" });
          } else {
            this.$toast(res.data.msg);
          }
        }
      });
    },
    routerGoBack() {
      if (window.history.length > 1) {
        let len = this.routerHistoryLng - history.length - 1; // -1是不进入iframe页面的下级页面直接退出的话，执行后退一步的操作
        if (this.routerHistoryLng > 2) {
          this.$router.go(len);
        } else {
          this.$router.replace({
            name: "Index",
          });
        }
      } else {
        this.$router.replace({
          name: "Index",
        });
      }
    },
    get_datas() {
      let url = "index.php/mobile/lesson/chapter";
      let params = {
        sys_id: localStorage.getItem("_sys_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        user_id: localStorage.getItem("_user_data_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        language: localStorage.getItem("_user_data_language"),
        trainplan_id: this.$route.query.tid,
        resources_id: this.$route.query.rid,
        chapter_id: this.$route.query.cid,
      };
      this.$axios.post(url, params).then((res) => {
        //   console.log('在线课程-获取章节内容接口', res)
        if (res.data.code == 0) {
          this.title = res.data.result.chapter_title;
          document.title = this.title;
          this.h5_url = res.data.result.file_path[0];
        } else {
          if (res.data.code == 10600) {
            this.$router.push({ name: "Login" });
          } else {
            this.$toast(res.data.msg);
          }
        }
      });
    },
    setTimerThree(time) {
      // 播放开始计时 暂时每隔1s+1
      var _this = this;
      _this.IntervalThree = setInterval(() => {
        setTimeout(() => {
          localStorage.setItem("left_time", time--);
          if (time <= 0) {
            clearInterval(_this.IntervalTwo);
            clearInterval(_this.IntervalThree);
            // 返回
            _this.$router.go(-1);
          }
        }, 0);
      }, 1000);
    },
    // 统计入库一波学习时长
    statisticDuration() {
      //   console.log('统计一波时长')
      return new Promise((resolve) => {
        let json = {
          type: "statisticDuration",
        };
        let str = JSON.stringify(json);
        if (window.lessonWS && window.lessonWS.ws) {
          window.lessonWS.ws.send(str);
        }
        resolve();
      });
    },
  },
  //   beforeRouteLeave(to, from, next) {
  //     // 导航离开该组件的对应路由时调用
  //     // 可以访问组件实例 `this`
  //     this.back()
  //     clearInterval(this.IntervalTwo)
  //     clearInterval(this.IntervalThree)
  //     // localStorage.removeItem('current')
  //     next()
  //   },
  beforeRouteLeave(to, from, next) {
    // console.log('beforeRouteLeave')
    this.statisticDuration();
    clearInterval(this.IntervalTwo);
    clearInterval(this.IntervalThree);
    next();
  },
  //   beforeDestroy () {
  //     console.log('beforeDestroy')
  //     window.removeEventListener('beforeunload', e => this.statisticDuration())
  //     clearInterval(this.IntervalTwo)
  //     clearInterval(this.IntervalThree)
  //   }
};
</script>
<style scoped lang="less">
.h5 {
  height: 100%;
  .content {
    position: relative;
    height: calc(100% - 0.72rem);
    //  iframe { pointer-events:none; }
  }
}
</style>
